import { DefaultService } from '@/services/DefaultService';

export default class FormularioService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    save(formulario, contexto = "pro") {
        return this._http.post(`${this._env}/${contexto}/form`, formulario, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    find(id, contexto = "pro") {
        return this._http.get(`${this._env}/${contexto}/form/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    delete(id, contexto = "pro") {
        return this._http.delete(`${this._env}/${contexto}/form/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAll(column, order, page = 0, limit = 50, situacao = 2, contexto = "pro", ...params) {
        return this._http.get(encodeURI(`${this._env}/${contexto}/form.json?column=${column}&order=${order}&page=${page}&limit=${limit}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllCombo(contexto = "pro", ...params) {
        return this._http.get(encodeURI(`${this._env}/${contexto}/getcombo/form.json?param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllAnswered(page = 0, limit = 50, contexto = "pro", ...params) {
        return this._http.get(encodeURI(`${this._env}/${contexto}/form/answered.json?page=${page}&limit=${limit}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAnswersFromForm(id, contexto = "pro") {
        return this._http.get(`${this._env}/${contexto}/form/answered/results/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacao(formulario, contexto = "pro") {
        return this._http.post(`${this._env}/${contexto}/form/updatesituacao`, formulario, this._headers).then(res => {
                return res.body;
        }, err => {
                this.verifyError(err);
                throw new Error("Problems while jobs are loading");
        });
    }

}